import React from 'react';
import "./Footer.css";

function Footer() {


  return (
    <footer className='footer'>
      <h5>
      DECENTRALIZED EXCHANGE - DO YOUR OWN RESEARCH - NOT RESPONSIBLE FOR LOST FUNDS
      </h5>
    </footer>
  );
}

export default Footer;
